import React from 'react';
import PropTypes from 'prop-types';
import styles from './variable.module.scss';
import useTranslate from '~hooks/useTranslate/useTranslate';

const VariableComponent = ({ item }) => {
  const bonusInfo = useTranslate('bonus_info', null)
  const gratisSpins = useTranslate('gratis_spins', null)
  return (
    <>
      {bonusInfo && <p className={styles.bonusInfo}>{bonusInfo}</p>}
      {gratisSpins && (
        <p className={styles.gratisSpins}>
          {gratisSpins}:{item?.bonus?.bonuses?.main?.freespins}
        </p>
      )}
    </>
  )
}

VariableComponent.propTypes = {
  item: PropTypes.shape({
    bonus: PropTypes.shape({
      bonuses: PropTypes.shape({
        main: PropTypes.shape({
          freespins: PropTypes.string
        })
      })
    })
  })
}

export default VariableComponent
